/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M stock → 1 M final in 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL of stock, topped up to 100 mL.`)
};

const es_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M stock → 1 M final en 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL de stock, completados hasta 100 mL.`)
};

const de_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M Stammlösung → 1 M Endkonzentration in 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL Stammlösung, aufgefüllt auf 100 mL.`)
};

const nl_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M stock → 1 M eindconcentratie in 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL stock, aangevuld tot 100 mL.`)
};

const fr_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M mère → 1 M final dans 100 mL : V1 = (1 M × 100 mL) / 10 M = 10 mL de solution mère, complétés à 100 mL.`)
};

const it_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soluzione madre 10 M → finale 1 M in 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL di madre, portati a 100 mL.`)
};

const pt_br2_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estoque 10 M → final 1 M em 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL de estoque, completado até 100 mL.`)
};

const pt_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solução-mãe 10 M → final 1 M em 100 mL: V1 = (1 M × 100 mL) / 10 M = 10 mL de solução-mãe, perfazendo 100 mL.`)
};

const ja_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M ストック → 100 mL 中で最終濃度 1 M: V1 = (1 M × 100 mL) / 10 M = ストック10 mLを100 mLまで満たす。`)
};

const zh_soldil_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 M 母液 → 100 mL 中配制 1 M 终浓度：V1 = (1 M × 100 mL) / 10 M = 10 mL 母液，加水定容至 100 mL。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_ex1", locale)
	if (locale === "en") return en_soldil_ex1(inputs)
	if (locale === "es") return es_soldil_ex1(inputs)
	if (locale === "de") return de_soldil_ex1(inputs)
	if (locale === "nl") return nl_soldil_ex1(inputs)
	if (locale === "fr") return fr_soldil_ex1(inputs)
	if (locale === "it") return it_soldil_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_ex1(inputs)
	if (locale === "pt") return pt_soldil_ex1(inputs)
	if (locale === "ja") return ja_soldil_ex1(inputs)
	return zh_soldil_ex1(inputs)
};